"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFactMetadataObject = void 0;
// (C) 2019-2020 GoodData Corporation
var types_1 = require("../types");
/**
 * Tests whether the provided object is of type {@link IFactMetadataObject}.
 *
 * @param obj - object to test
 * @public
 */
function isFactMetadataObject(obj) {
    return types_1.isMetadataObject(obj) && obj.type === "fact";
}
exports.isFactMetadataObject = isFactMetadataObject;
//# sourceMappingURL=index.js.map